import {Article} from "../../data/types";
import "../../styles/styles.css"
import axios from "axios";
import React, { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});
const PageMedias = () => {
   const [article, setArticle] = useState<Article>({image:'',date:'',titre: '', description: '',index:0,categorie:'',href:'',html:''})
      useEffect(() => {
        const getArticle = async () => {
          var response:any=[];
          try {
            response = await axiosInstance.get("api/articles/article/Ahuncycledanslesmedias");
            setArticle(response.data);
          } catch (error) {
            console.log("erreur:"+error);
          }
        }
        getArticle(); 
            
      }, [])
     
  return (
     <div style={{marginLeft:"50px",marginTop:"50px",marginRight:"50px",textAlign:"justify"}}> 
      <div className="article" id="lien" dangerouslySetInnerHTML={{ __html: article.html }}>
      </div>
    </div>
  ); 
};

export default PageMedias;
